/**
 * 营销工具模块路由
 * 路径前缀: /desktopCenter/marketingTools/
 */
import type { RouteRecordRaw } from "vue-router";

export const marketingToolsRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/marketingTools/billPass",
		name: "billPass",
		meta: {
			title: "惠票通",
			keepAlive: false,
		},
		redirect: "/desktopCenter/marketingTools/billPass/coupon",
		children: [
			{
				path: "/desktopCenter/marketingTools/billPass/coupon",
				name: "BillPassCoupon",
				meta: {
					title: "优惠券",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/MarketingTools/BillPass/BillPassCoupon/BillPassCoupon.vue"),
			},
			{
				path: "/desktopCenter/marketingTools/billPass/activityTask",
				name: "BillPassActivityTask",
				meta: {
					title: "活动任务",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/MarketingTools/BillPass/ActivityTask/ActivityTask.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/marketingTools/activityChain",
		name: "ActivityChain",
		meta: {
			title: "活动接龙",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/jielong",
		},
		component: () => import("@main/views/Apps/MarketingTools/ActivityChain/ActivityChain.vue"),
	},
	{
		path: "/desktopCenter/marketingTools/questionnaireSurvey",
		name: "QuestionnaireSurvey",
		meta: {
			title: "问卷调查",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/questionnaire/questionnaire",
		},
		component: () =>
			import("@main/views/Apps/MarketingTools/QuestionnaireSurvey/QuestionnaireSurvey.vue"),
	},
	{
		path: "/desktopCenter/marketingTools/supplyDemand",
		name: "SupplyDemand",
		meta: {
			title: "供需对接",
			keepAlive: false,
		},
		redirect: "/desktopCenter/marketingTools/supplyDemand/list",
		children: [
			{
				path: "/desktopCenter/marketingTools/supplyDemand/list",
				name: "SupplyDemandList",
				meta: {
					title: "供需列表",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/business/business",
				},
				component: () =>
					import(
						"@main/views/Apps/MarketingTools/SupplyDemand/SupplyDemandList/SupplyDemandList.vue"
					),
			},
			{
				path: "/desktopCenter/marketingTools/supplyDemand/category",
				name: "SupplyDemandCategory",
				meta: {
					title: "供需分类",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/business/category",
				},
				component: () =>
					import(
						"@main/views/Apps/MarketingTools/SupplyDemand/SupplyDemandCategory/SupplyDemandCategory.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/marketingTools/demandFeedback",
		name: "DemandFeedback",
		meta: {
			title: "需求反馈",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/demand",
		},
		component: () => import("@main/views/Apps/MarketingTools/DemandFeedback/DemandFeedback.vue"),
	},
];
